import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTranslation } from 'react-i18next';
import { useParams, Link as RouterLink } from 'react-router-dom';

import AlertMessage from '../../../components/elements/alert-message/AlertMessage';
import CopyableText from '../../../components/elements/copyable-text/CopyableText';
import Loading from '../../../components/elements/loading/Loading';
import Title from '../../../components/elements/title/Title';
import InstanceTabs from '../../../components/page-sections/instance-tabs/InstanceTabs';
import Breadcrumbs from '../../../components/sections/breadcrumbs/Breadcrumbs';
import Overview from '../../../components/sections/overview/Overview';
import { useProject } from '../../../contexts/ProjectContext';
import { useUser } from '../../../contexts/UserContext';
import { buildPath, PRIVATE_ROUTE } from '../../../routes/routes';
import { sentenceCase } from '../../../utils/utils';

// Page
const ProjectOverviewPage = () => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const { projectId } = useParams();
  const { error, loading, project } = useProject();
  const { t } = useTranslation();
  const { user } = useUser();

  const newInstanceButton = user?.isAdmin?.(projectId) && (
    <Button
      id="new-instance"
      fullWidth={isSmallScreen}
      component={RouterLink}
      to={buildPath({
        path: PRIVATE_ROUTE.INSTANCE_NEW,
        params: { projectId: projectId },
      })}
      variant="contained"
      color="primary"
    >
      {t('createInstance', { ns: 'buttons' })}
    </Button>
  );

  if (loading) return <Loading />;

  if (error)
    return (
      <AlertMessage
        severity="error"
        message={sentenceCase(
          t('loading', {
            ns: 'errors',
            content: t('projectInfo', { ns: 'project' }),
          })
        )}
      />
    );

  return (
    <Container>
      <Breadcrumbs />
      <Overview data={project} button={newInstanceButton} />
      <Box>
        <CopyableText
          text={projectId}
          label={t('projectId', { ns: 'project' })}
        />
      </Box>
      <Title subTitle text={t('instances', { ns: 'instance' })} />
      <InstanceTabs projectId={projectId} />
    </Container>
  );
};
export default ProjectOverviewPage;
